import {
    ModuleWithProviders, NgModule,
    Optional, SkipSelf }       from '@angular/core';
import { CommonModule }      from '@angular/common';
import { UserService }       from './providers/user-service';
@NgModule({
    imports: [CommonModule],
    declarations: [],
    exports: [],
    providers: [UserService]
})
export class CoreModule {
}
 


// WEBPACK FOOTER //
// ./src/app/core/core.module.ts